if (!customElements.get('ingredients-grid')) {
  class IngredientsGrid extends HTMLElement {
    constructor() {
      super();
      this.keyIngredientsBtn = this.querySelector('.key-ingredients');
      this.ingredientsListBtn = this.querySelector('.ingredients-list');
      this.keyIngredientsContainer = this.querySelector('.key-ingredients-container');
      this.ingredientsListContainer = this.querySelector('.ingredients-list-container');

      this.showIngredientsList = this.showIngredientsList.bind(this);
      this.showKeyIngredients = this.showKeyIngredients.bind(this);
    }

    connectedCallback() {
      this.keyIngredientsBtn.addEventListener('click', this.showKeyIngredients);
      this.ingredientsListBtn.addEventListener('click', this.showIngredientsList);
    }

    showKeyIngredients() {
      this.ingredientsListBtn.classList.remove('active');
      this.keyIngredientsBtn.classList.add('active');
      this.keyIngredientsContainer.classList.remove("hidden-container");
      this.ingredientsListContainer.classList.add("hidden-container");
    }

    showIngredientsList() {
      this.keyIngredientsBtn.classList.remove('active');
      this.ingredientsListBtn.classList.add('active');
      this.ingredientsListContainer.classList.remove("hidden-container");
      this.keyIngredientsContainer.classList.add("hidden-container");
    }
  }

  customElements.define('ingredients-grid', IngredientsGrid);
}
